export default "__VITE_ASSET__Cw9Wqcyq__"